export default "__VITE_ASSET__CWs$Ewbm__"